import magnifier from "../../assets/images/svg/magnifier"
import downArrow from "../../assets/images/svg/downArrow"

const SearchWishesBar = ({ search, setSearch, setOrder }) => {

  const handleSearchBar = (e) => {
    e.preventDefault()
    setSearch(e.target.value)
  }

  const handleOrder = (e) => {
    e.preventDefault()
    setOrder(e.target.value)
  }

  return (
    <div className="w-full global-px mt-5 pb-3 mb-2 bg-white flexJustifyItemsCenter flex-col gap-4 text-darkRed shadow-lg shadow-ivory sm:justify-between sm:flex-row lg:text-2xl">
      <div className="relative w-full flex justify-start items-center sm:w-1/2">
        {magnifier}
        <input
          className="w-full pl-8 pr-2 py-1.5 bg-ivory shadow-sm shadow-darkRed rounded placeholder:text-darkRed"
          placeholder="Rechercher un souhait"
          type="text"
          value={search}
          onChange={handleSearchBar}
          name="search"
        />
      </div>
      <div className="relative w-full flexJustifyItemsCenter sm:w-1/2">
        <select
          name="filter"
          onChange={handleOrder}
          value={"Trier"}
          className="w-full pl-2 pr-7 py-1.5 bg-ivory shadow-sm shadow-darkRed rounded text-center"
        >
          <option value="Trier" hidden disabled>Trier</option>
          <option value="alphabetical">Par ordre alphabétique</option>
          <option value="cheaper_first">Du moins cher au plus cher</option>
          <option value="expensive_first">Du plus cher au moins cher</option>
        </select>
        {downArrow}
      </div>
    </div>
  )
}

export default SearchWishesBar